import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import ROUTER_CONFIG from '../../../../router/router-config';
import LogoLayout from '../../../layout/LogoLayout';
import FundraisingOverview from './FundraisingOverview';
import { formatDateDDMMMYYYY, formatDateDDMMYY } from '../../../../ui/DateFormatMethods';
import { selectSchoolFundraisingData, loadSchoolFundraisingData } from '../../../../feature/schoolsState';
import { showPriceDigits, formatDateString } from '../../../../utils/formats';

export interface TableRow {
  key: string;
  name: string;
  startDate: string;
  endDate: string;
}

export type TableColumns = Array<{ title: string; dataIndex: keyof TableRow; key: keyof TableRow; }>;

export default function FundraisingOverviewPage() {
  const { push } = useHistory();
  const dispatch = useDispatch();
  const campaignList = useSelector(selectSchoolFundraisingData);

  const [selectedCollectionPeriod, setSelectedCollectionPeriod] = useState<[string, string]>(['', '']);

  useEffect(() => {
    const startDate = selectedCollectionPeriod[0] ? formatDateString(selectedCollectionPeriod[0]) : '';
    const endDate = selectedCollectionPeriod[1] ? formatDateString(selectedCollectionPeriod[1], true) : '';

    dispatch(loadSchoolFundraisingData());
  }, [dispatch, selectedCollectionPeriod]);

  const tableRows: Array<TableRow> = campaignList.map(
    (campaign) => ({
      key: campaign.schemeName,
      name: campaign.schemeName,
      startDate: formatDateDDMMYY(new Date(campaign.startDate)),
      endDate: campaign.endDate !== '∞' ? formatDateDDMMYY(new Date(campaign.endDate)) : '∞',
    }),
  );

  const onBack = () => {
    if (campaignList.length > 0) {
      push(ROUTER_CONFIG.SCHOOL_CAMPAIGN_INFO.getPath({ campaignId: campaignList[0].id }));
    } else {
      push(ROUTER_CONFIG.SCHOOL_CAMPAIGN_CREATE.getPath());
    }
  };

  return (
    <LogoLayout>
      <FundraisingOverview onChangeTimePeriod={setSelectedCollectionPeriod} tableRows={tableRows} onBack={onBack} />
    </LogoLayout>
  );
}
